
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

export { getBasePlacement as default };
//# sourceMappingURL=getBasePlacement.js.map
